const API_BASE_URL = process.env.NODE_ENV === 'production'
    ? '/api'
    : (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001/api');

const API_ROUTESPECIFIC = {
    jobRoute: 'jobs',
    imageRoute: 'images',
    referenceRoute: 'references',
    loginRoute: 'login',
    supportDocument: 'support-documents',
    registerRoute: 'user',
    blogRoute: 'blog',
    videoRoutes: 'video'
}
export const API_ENDPOINTS = {
    getAllJobs: `${API_BASE_URL}/${API_ROUTESPECIFIC.jobRoute}/fetch-all-jobs`,
    getAllJobsMulti: `${API_BASE_URL}/${API_ROUTESPECIFIC.jobRoute}/fetch-jobs-multilang`,
    
    getAllNewJobs :`${API_BASE_URL}/${API_ROUTESPECIFIC.jobRoute}/fetch-all-new-jobs`,
    getAllNewJobsMulti : `${API_BASE_URL}/${API_ROUTESPECIFIC.jobRoute}/fetch-all-new-jobs-mulitlang`,
    
    postJob: `${API_BASE_URL}/${API_ROUTESPECIFIC.jobRoute}/post-job`,
    postNewJob: `${API_BASE_URL}/${API_ROUTESPECIFIC.jobRoute}/post-new-job-multilang`,
    
    postMultiLangJob: `${API_BASE_URL}/${API_ROUTESPECIFIC.jobRoute}/post-job-multiLang`,
    
    updateJob : `${API_BASE_URL}/${API_ROUTESPECIFIC.jobRoute}/update-job`,
    updateNewJob: `${API_BASE_URL}/${API_ROUTESPECIFIC.jobRoute}/update-new-job`,
    
    getSingleJob : `${API_BASE_URL}/${API_ROUTESPECIFIC.jobRoute}/fetch-job`,
    getSingleNewJob: `${API_BASE_URL}/${API_ROUTESPECIFIC.jobRoute}/fetch-new-job`,
    
    deleteSingleJob: `${API_BASE_URL}/${API_ROUTESPECIFIC.jobRoute}/delete-job`,
    deleteSingleJobMultiLang:  `${API_BASE_URL}/${API_ROUTESPECIFIC.jobRoute}/delete-job-multilang`,

    deleteSingleNewJob: `${API_BASE_URL}/${API_ROUTESPECIFIC.jobRoute}/delete-new-job`,
    deleteSingleNewJobMultiLang:  `${API_BASE_URL}/${API_ROUTESPECIFIC.jobRoute}/delete-new-job-multilang`,
    
    postReferences: `${API_BASE_URL}/${API_ROUTESPECIFIC.referenceRoute}/post-reference`,
    getAllReferences: `${API_BASE_URL}/${API_ROUTESPECIFIC.referenceRoute}/all-references`,
    getSingleReference: `${API_BASE_URL}/${API_ROUTESPECIFIC.referenceRoute}/fetch-reference`,
    deleteSingleReference: `${API_BASE_URL}/${API_ROUTESPECIFIC.referenceRoute}/delete-reference`,

    uploadImage: `${API_BASE_URL}/${API_ROUTESPECIFIC.imageRoute}/upload-image`,

    loginUser: `${API_BASE_URL}/${API_ROUTESPECIFIC.loginRoute}/login-user`,

    uploadPdf: `${API_BASE_URL}/${API_ROUTESPECIFIC.supportDocument}/upload-pdf`,
    postSupportDocument: `${API_BASE_URL}/${API_ROUTESPECIFIC.supportDocument}/post-support-document`,

    registerNewUser: `${API_BASE_URL}/${API_ROUTESPECIFIC.registerRoute}/register/register-user`,

    postNewBlog: `${API_BASE_URL}/${API_ROUTESPECIFIC.blogRoute}/post-blog`,
    getAllBlogs: `${API_BASE_URL}/${API_ROUTESPECIFIC.blogRoute}/get-all-blogs`,
    getSingleBlog: `${API_BASE_URL}/${API_ROUTESPECIFIC.blogRoute}/get-single-blog`,
    updateBlog: `${API_BASE_URL}/${API_ROUTESPECIFIC.blogRoute}/update-blog`,       
    deleteBlog: `${API_BASE_URL}/${API_ROUTESPECIFIC.blogRoute}/delete-blog`,

    uploadVideo: `${API_BASE_URL}/${API_ROUTESPECIFIC.videoRoutes}/upload-video`,
    
    postCustomerAddress: `${API_BASE_URL}/${API_ROUTESPECIFIC.referenceRoute}/post-customer-address`,
};
